import Button from '../../Button'
import Dialog from '../../Dialog'

const NexusAvailableModal = ({ isOpen, onContinue }) => {
  return (
    <Dialog
      isOpen={isOpen}
      setIsOpen={null}
      title="Topgear Nexus is available for this file"
      buttonProps={null}
    >
      <div className="mt-4">
        <p className="text-sm text-gray-600">
          If the options you need are not available with Topgear Nexus, you can
          request a manual file.
        </p>
        <div className="mt-6 flex justify-end">
          <Button color="primary" onClick={onContinue}>
            Continue
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

export default NexusAvailableModal
